import React, { ReactNode, useEffect, useState } from 'react';
import './GeneralRecipeViewCard.scss';
import CustomCheckBox from '../../../components/CustomCheckBox';
import { Medicine } from '../../../interface/interface';

export const addLineBreaksAndStippling = (string: string, bold: boolean) => { //una cadena que viene con \n literal, se reemplaza por salto de linea y lo puntea por cada \n
    const formattedString:string = string.replace(/\\n/g, '\n').trim();
    const splittedFormattedString:string[] = formattedString.split('\n')

    return <ul style={{ listStyleType: 'disc', paddingLeft: '20px', fontWeight: 500 }}>
                <p style={{fontWeight: bold? 600 : ''}}>
                    {splittedFormattedString.map((line, index) => (
                        <li key={index}>{line}</li>
                    ))}
                </p>
            </ul>
}

interface GeneralRecipeViewCardProps {
    title: string | ReactNode;
    detail?: string | ReactNode;
    medicineList?: Medicine[]
    detail2?: string | ReactNode;
    detail3?: string | ReactNode;
    detail4?: string | ReactNode;
    onClick: () => void;
    backgroundColor?: string;
    titleColor?: string;
    detailColor?: string;
    detailFontSize?: string;
    border?: string;
    borderRadius?: string;
    boxShadow?: string;
    onEdit?: () => void;
    onRemove?: () => void;
    showCheckbox?: boolean;
    isChecked?: boolean;
    onCheckboxChange?: () => void;
    changeColorIfActive?: boolean;
    style?: React.CSSProperties;
}

const GeneralRecipeViewCard: React.FC<GeneralRecipeViewCardProps> = ({
    title,
    detail,
    medicineList,
    detail2,
    detail3,
    detail4,
    onClick,
    backgroundColor = '#EAEFEE',
    titleColor = '#000000',
    detailColor = '#000000',
    detailFontSize = '1rem',
    border = '1px solid #009688',
    borderRadius = '5px',
    boxShadow = 'none',
    onEdit,
    onRemove,
    showCheckbox = false,
    isChecked = false,
    onCheckboxChange,
    changeColorIfActive = false,
    style = {}
}) => {
    const [isActive, setIsActive] = useState(changeColorIfActive);

    const cardStyle: React.CSSProperties = {
        backgroundColor, border, borderRadius, boxShadow, padding: '10px', marginBottom: '15px', position: 'relative',
        ...style,
    };

    useEffect(() => {
        setIsActive(changeColorIfActive);
    }, [changeColorIfActive]);

    return (
        <div className={`general-recipe-view-card ${isActive ? 'active' : ''}`} onClick={onClick} style={cardStyle}>
            <div style={{ display: 'flex' }}>
                {showCheckbox && (
                    <div>
                        <CustomCheckBox
                            checked={isChecked}
                            onChange={(e) => { e.stopPropagation(); if (onCheckboxChange) onCheckboxChange(); }}
                        />
                    </div>
                )}
                <div style={{ marginLeft: '2px', paddingLeft: '0px', paddingRight: (onEdit && onRemove)?'56px':'' }}>
                    <div style={{ color: isActive ? '#FFFFFF' : titleColor }}>{title}</div>
                    {detail && <div style={{ marginTop: '2px', color: detailColor, fontSize: detailFontSize }} className="detail">{detail}</div>}
                    {medicineList && <div>{medicineList.map((e: Medicine, index) => (<div className="detail" style={{ marginBottom: '4px', marginTop: '2px', color: detailColor, fontSize: detailFontSize, fontWeight: 600 }} key={index}>{e.drugdescription + ' ' + e.presentationdescription}</div>))}</div>}
                    <div style={{ marginTop: '2px' }} className="detail2">{detail2}</div>
                    <div style={{ marginTop: '2px' }} className="detail2">{detail3}</div>
                    <div style={{ marginTop: '2px' }} className="detail2">{detail4}</div>
                </div>
            </div>
            <div className='gap-2' style={{ display: 'flex', flexDirection: 'row', position: 'absolute', top: '10px', right: '10px' }}>
                {onEdit && (
                    <div className="remove-button" onClick={(e) => {
                        e.stopPropagation();
                        onEdit();
                    }}>
                        <i style={{ fontSize: '20px' }} className="pi pi-pen-to-square"></i>
                    </div>
                )}
                {onRemove && (
                    <div className="remove-button" onClick={(e) => {
                        e.stopPropagation();
                        onRemove();
                    }}>
                        <i style={{ fontSize: '20px' }} className="pi pi-times-circle"></i>
                    </div>
                )}
            </div>
        </div>
    );    
    
};

export default GeneralRecipeViewCard;
